import { combineReducers } from '@reduxjs/toolkit';
import atomicTimeReducer from './slices/atomicTime/atomicTimeSlice';
import auctionPoolingReducer from './slices/auctionPoolingUpdater/auctionPoolingSlice';
import configurableFiltersReducer from './slices/buyers/filters/filtersSlice';
import buyerTimedSaleVehiclesReducer from './slices/buyerVehicles/buyerVehicles';
import checkoutReducer from './slices/checkout';
import dealDriverReducer from './slices/dealDriver/slice';
import dealDriverGoodwillReducer from './slices/dealDriver/goodwill/slice';
import gtvOfferIndexReducer from './slices/gtvOffer/gtvOfferIndex';
import gtvOfferShowReducer from './slices/gtvOffer/gtvOfferShow';
import loggedUserReducer from './slices/loggedUsers/loggedUserSlice';
import observedBidSalesReducer from './slices/observedBidSales/observedBidSalesSlice';
import buyerOfferSummary from './slices/offerSummary/buyerOfferSummary';
import referAFriendReducer from './slices/referAFriend/referAFriendSlice';
import savedSearchReducer from './slices/savedSearch/savedSearchSlice';
import sellerBidSalesReducer from './slices/sellers/bidSales/slice';
import vehicleCardModalsReducer from './slices/sellers/vehicleCardModals/vehicleCardModalsSlice';
import transportDashboardReducer from './slices/transportDashboard/slice';
import treatmentsSliceReducer, { SLICE_NAME as treatMentSliceName } from './slices/treatments/treatmentsSlice';
import signUpReducer from './slices/signUp/signUpSlice';
import settingsReducer from './slices/settings/slice';
import bulkEditIndexReducer from './slices/bulkEdit/bulkEditIndex';
import transactionsLedgerReducer from './slices/transactionsLedger/slice';
import selfServeCreditBalancesReducer from './slices/selfServeCreditBalances/slice';
import selfServeCreditsReducer from './slices/selfServeCredits/slice';

export default combineReducers({
	vehicleCardModals: vehicleCardModalsReducer,
	sellerBidSales: sellerBidSalesReducer,
	buyerVehicles: buyerTimedSaleVehiclesReducer,
	observedBidSales: observedBidSalesReducer,
	buyerOfferSummary: buyerOfferSummary,
	atomicTime: atomicTimeReducer,
	auctionPooling: auctionPoolingReducer,
	searchFilters: configurableFiltersReducer,
	loggedUser: loggedUserReducer,
	checkout: checkoutReducer,
	referAFriend: referAFriendReducer,
	gtvOfferShow: gtvOfferShowReducer,
	gtvOfferIndex: gtvOfferIndexReducer,
	savedSearch: savedSearchReducer,
	transportDashboard: transportDashboardReducer,
	dealDriver: dealDriverReducer,
	dealDriverGoodwill: dealDriverGoodwillReducer,
	[treatMentSliceName]: treatmentsSliceReducer,
	signUp: signUpReducer,
	settings: settingsReducer,
	bulkEditIndex: bulkEditIndexReducer,
	transactionsLedger: transactionsLedgerReducer,
	selfServeCreditBalances: selfServeCreditBalancesReducer,
	selfServeCredits: selfServeCreditsReducer,
});
